import React, { useEffect, useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Footer } from "./layout-parts/Footer"
import { Header } from "./layout-parts/Header"
import ScrollToTop from "react-scroll-to-top"
import { PopUp } from "./pop-up"

const Layout = ({ isHomePage, children }) => {
  let edges = []
  const { allWpRoundup, allWpProduct, allWpPost
  } = useStaticQuery(graphql`
    query LayoutQuery {
      allWpRoundup(limit: 660) {
        edges {
          node {
            title
            uri
            featuredImage {
              node {
                gatsbyImage(
                  outputPixelDensities: 1.5
                  fit: COVER
                  formats: AUTO
                  cropFocus: CENTER
                  width: 550
                ) 
              }
            }
          }
        }
      }
      allWpProduct(limit: 660)  {
        edges {
          node {
            uri
            title
            featuredImage {
              node {
                gatsbyImage(
                  outputPixelDensities: 1.5
                  fit: COVER
                  formats: AUTO
                  cropFocus: CENTER
                  width: 550
                ) 
              }
            }
          }
        }
      }
      allWpPost(limit: 660)  {
        edges {
          node {
            uri
            title
            featuredImage {
              node {
                gatsbyImage(
                  outputPixelDensities: 1.5
                  fit: COVER
                  formats: AUTO
                  cropFocus: CENTER
                  width: 550
                ) 
              }
            }
          }
        }
      }
    }
  `)

  let allPosts = allWpRoundup.edges.concat( allWpProduct.edges, allWpPost.edges )

  const [ showPopUp, setShowPopUp ] = useState( false )

  const checkPopUp = async () => {
    const response = await fetch( 'https://api.country.is' )
    const geoData = await response.json()
    const date = new Date()
    date.setTime(date.getTime()+(30*24*60*60*1000))
    if ( 'US' === geoData.country ) {
      setShowPopUp( true )
      document.cookie = `subscription_pop_up=true; expires=${date.toGMTString()}; path=/;`
    } else {
      document.cookie = `subscription_pop_up=false; expires=${date.toGMTString()}; path=/;`
    }
  }

  function getCookie(cname) {
    let name = cname + "="
    let ca = document.cookie.split(';')
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length)
      }
    }
    return ""
  }

  useEffect( () => {

    let popUp = getCookie('subscription_pop_up')
    
    if ( popUp === '' ) {

      let timer = setTimeout(() => {
        checkPopUp()
      }, 10000)
  
      return () => {
        clearTimeout(timer)
      }
     
    }

  }, [])

  return (
      <>
      {'en' === process.env.GATSBY_SITE_LANG &&
      <noscript>
        <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NKZFV8ZT" height="0" width="0" style={{ display : 'none', visibility : 'hidden' }}></iframe>
      </noscript>}

      {'de' === process.env.GATSBY_SITE_LANG &&
      <noscript>
        <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MFZ5CVJ5" height="0" width="0" style={{ display : 'none', visibility : 'hidden' }}></iframe>
      </noscript>}
      
      <div className="global-wrapper" data-is-root-path={isHomePage}>

        <Header wpMenu={edges} allPosts={allPosts}/>

        <main className="main">{children}</main>

        <Footer wpMenu={edges}/>

        {/* {showPopUp && <PopUp setShowPopUp={setShowPopUp}/>} */}

        <ScrollToTop
          className="scroll-to-top-btn"
          svgPath="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
          viewBox="0 0 16 16"
          smooth />

      </div>
      </>
    
  )
}

export default Layout
